module.exports = __webpack_public_path__ + "img/4e4366151b304c709ed3f9fa603d625a.2ea5b6ee.png";